import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Trash2 } from "lucide-react";
import { api, fmtDate, fmtErr } from "@/api";
import { useLang } from "@/i18n";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ROLE_STYLE = {
  admin: "bg-[#D4AF37]/20 text-emerald-950 border border-[#D4AF37]",
  kontributor: "bg-emerald-100 text-emerald-900 border border-emerald-300",
  alumni: "bg-slate-100 text-slate-700 border border-slate-300",
};

export default function KelolaAkunTab() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get("/admin/accounts").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const filtered = items.filter((u) => u.name.toLowerCase().includes(q.toLowerCase()) || u.email.toLowerCase().includes(q.toLowerCase()));

  const remove = async (u) => {
    if (!window.confirm(t("common.confirm_delete"))) return;
    try {
      await api.delete(`/admin/accounts/${u.id}`);
      toast.success(t("common.deleted"));
      load();
    } catch (err) { toast.error(fmtErr(err)); }
  };

  return (
    <div data-testid="kelola-akun-tab">
      <p className="text-sm text-slate-500 mb-4">{t("dash.kelola_akun_sub")}</p>
      <div className="relative max-w-sm mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="..." className="pl-9" data-testid="akun-search-input" />
      </div>
      <div className="bg-white rounded-xl border border-emerald-900/10 shadow-sm overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("auth.name")}</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>{t("alumni.tahun_lulus")}</TableHead>
              <TableHead>Terdaftar</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((u) => (
              <TableRow key={u.id} data-testid={`akun-row-${u.id}`}>
                <TableCell className="font-medium">{u.name}</TableCell>
                <TableCell className="text-xs">{u.email}</TableCell>
                <TableCell>
                  <Badge className={`${ROLE_STYLE[u.role] || ""} hover:bg-none`} data-testid={`akun-role-${u.id}`}>
                    {t(`dash.role.${u.role}`)}
                  </Badge>
                </TableCell>
                <TableCell className="text-xs">{u.alumni_profile?.tahun_lulus || "—"}</TableCell>
                <TableCell className="text-xs">{fmtDate(u.created_at, lang)}</TableCell>
                <TableCell>
                  {u.role !== "admin" && (
                    <Button size="sm" variant="destructive" onClick={() => remove(u)} data-testid={`akun-delete-${u.id}`}>
                      <Trash2 className="h-3.5 w-3.5 mr-1" />{t("common.delete")}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
